



export function sendMessageToPreview(message) {
  if (typeof window !== "undefined") {
    if (document.getElementById("website-preview-frame")) {
      // @ts-ignore
      document.getElementById("website-preview-frame").contentWindow
        .postMessage({universal: message}, "*");
    }
  }
}


export function generateRandomObjectId() {
  var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function() {
    return (Math.random() * 16 | 0).toString(16);
  }).toLowerCase();
}

export function generateRandomId() {
  // generate a random objectid (12 bytes)
  var timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
  return (
    timestamp +
    "xxxxxxxxxxxxxxxx"
      .replace(/[x]/g, function () {
        return ((Math.random() * 16) | 0).toString(16);
      }
      )
      .toLowerCase()
  );
}

export function expandConditionForCurrentQuestion(condition, replaceIdentifier, question, list) {
  condition = JSON.parse(JSON.stringify(condition));
  condition.id = generateRandomId();
  if (condition.jsonQuery) {
    condition.jsonQuery = expandConditionForCurrentQuestion(condition.jsonQuery, replaceIdentifier, question, list);
  }
  else if (typeof condition.type !== "undefined") {
    if (condition.children1) {
      for (const e of condition.children1) {
        if (e.type === "rule") {
          if (e.properties.field) {
            if (list.find((f) => f.id === e.properties.field)) {
              e.properties.field = replaceIdentifier.replace("{{id}}", e.properties.field);
            }
          }
        }
      }
    }
  }

  return condition;
}



function getRelativePos(elm, container){
  var pPos = container.getBoundingClientRect(), // parent pos
    cPos = elm.getBoundingClientRect(), // target pos
    pos = {};

  pos.top    = container.scrollTop + cPos.top,
    pos.right  = cPos.right ,
    pos.bottom = cPos.bottom ,
    pos.left   = cPos.left  ;

  return pos;
}


export function scrollIfNeeded(element, container) {
  const pos = getRelativePos(element, container);
  if (pos.top < container.scrollTop) {
    container.scrollTo({ top: pos.top-130, behavior: 'smooth' });
  }
}


/**
 * Scrollt ein Element im Container in den Blick - in BEIDE Richtungen.
 *
 * scrollIfNeeded springt nur nach oben (nur wenn pos.top < container.scrollTop) und
 * taugt deshalb nicht, um auf einen Fehler weiter unten zu zeigen.
 */
export function scrollElementIntoViewInContainer(element, container, offset = 130) {
  if (!element || !container) {
    return;
  }
  try {
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const top = container.scrollTop + (elementRect.top - containerRect.top) - offset;
    container.scrollTo({ top: (top < 0) ? 0 : top, behavior: 'smooth' });
  }
  catch (e) {
    try {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    catch (e2) {
      // kein Scrollen moeglich - dann bleibt es beim roten Rahmen
    }
  }
}


/**
 * Laesst ein Element kurz aufleuchten.
 *
 * Die Klasse wird imperativ gesetzt und nach der Animation wieder entfernt. Rendert
 * React das Element zwischendurch neu, verschwindet sie frueher - dann blinkt es nur
 * kuerzer, kaputt geht nichts. Das kurze Auslesen von offsetWidth erzwingt einen
 * Reflow, sonst startet die Animation beim zweiten Klick auf "Weiter" nicht neu.
 */
export function flashElement(element, className = 'attention-flash', duration = 1600) {
  if (!element || !element.classList) {
    return;
  }
  try {
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
    setTimeout(() => {
      try {
        element.classList.remove(className);
      }
      catch (e) {
        // Element kann inzwischen ausgetauscht sein
      }
    }, duration);
  }
  catch (e) {
    // ohne classList kein Aufleuchten - der rote Rahmen bleibt trotzdem
  }
}



export function sendFullWebsiteUpdate(website, qCtrl) {
  return new Promise( (resolve, reject) => {
    if (typeof window !== "undefined") {
      if (document.getElementById("website-preview-frame")) {

        const targetUrl = qCtrl.formular.state.websitePreview.previewURL;
        if (targetUrl != null) {
          if (targetUrl != window.websiteconfig_targetUrl) {
            qCtrl.getPageDataByPath(targetUrl)
              .then((pageData) => {
                if (pageData && pageData.data) {
                  website.page = pageData.data.data;
                }
                website = qCtrl.updateWebsiteObjectBeforePreview(website);
                // @ts-ignore
                document.getElementById("website-preview-frame").contentWindow
                  .postMessage({full_update: website, path: targetUrl}, "*");
                window.websiteconfig_targetUrl = targetUrl;
              });
          }
          else {
            website = qCtrl.updateWebsiteObjectBeforePreview(website);
            // @ts-ignore
            document.getElementById("website-preview-frame").contentWindow
              .postMessage({full_update: website, path: window.websiteconfig_targetUrl}, "*");
          }
        }
        else {
          website = qCtrl.updateWebsiteObjectBeforePreview(website);
          // @ts-ignore
          document.getElementById("website-preview-frame").contentWindow
            .postMessage({full_update: website, path: window.websiteconfig_targetUrl}, "*");
        }


      }
    }
    return resolve();
  });

}

